module.exports = __webpack_public_path__ + "img/V-L-4-unload-standup-shadow.d0905650.png";